import React, { ReactElement } from 'react';
import { ReactComponent as ErrorFill } from '@assets/icons/error-fill.svg';
import { ReactComponent as RangeEnd } from '@assets/icons/PlayerControlBar/range-end.svg';
import { ReactComponent as RangeStart } from '@assets/icons/PlayerControlBar/range-start.svg';
import { ReactComponent as Photo } from '@assets/icons/photo.svg';
import { ReactComponent as ShapesDrawingDelete } from '@assets/icons/ShapesDrawingTools/delete.svg';
import * as Icons from '@icons';
import type { IconProps } from '@icons';

import './IconsPreview.less';

type IconEntry = [string, (props: IconProps) => ReactElement];

const allIcons = Object.entries(Icons) as IconEntry[];

const leftoverIcons: IconEntry[] = [
  ['photo.svg', Photo],
  ['error-fill.svg', ErrorFill],
  ['PlayerControlBar/range-start.svg', RangeStart],
  ['PlayerControlBar/range-end.svg', RangeEnd],
  ['ShapesDrawingTools/delete.svg', ShapesDrawingDelete]
];

function IconsPreview() {
  return (
    <div className="icons-preview">
      <h1 className="icons-preview__title">Icons</h1>
      <div className="icons-preview__grid">
        {allIcons.map(([name, Icon]) => (
          <div key={name} className="icons-preview__card">
            <span className="icons-preview__icon">
              <Icon className="icons-preview__svg" />
            </span>
            <span className="icons-preview__name">{name}</span>
          </div>
        ))}
      </div>
      <h2 className="icons-preview__title icons-preview__title--leftover">
        CSS / canvas
      </h2>
      <div className="icons-preview__grid">
        {leftoverIcons.map(([name, Icon]) => (
          <div
            key={name}
            className="icons-preview__card icons-preview__card--leftover"
          >
            <span className="icons-preview__icon">
              <Icon className="icons-preview__svg" />
            </span>
            <span className="icons-preview__name">{name}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default IconsPreview;
